import type { PaperProps } from '@mui/material';
import { Paper, Typography } from '@mui/material';
import { grey } from 'src/theme';
import { Iconify } from '../iconify';
import { Image } from '../image';

interface Props extends PaperProps {
  image_asset: string;
  name: string;
  onClick?: () => void;
}

export const CityAgentCard = (props: Props) => (
  <Paper
    elevation={8}
    className="text-white flex flex-col"
    onClick={props.onClick}
    sx={{
      borderRadius: '20px',
      cursor: 'pointer',
      '&:hover': {
        background: 'linear-gradient(180deg, #FFF 0%, #FFF 36.84%, #FEFE01 100%)',
      },
    }}
  >
    <Image
      ratio="3/4"
      src={props.image_asset}
      alt={props.name}
      className="rounded-[20px] pl-[10px] pt-[10px] pr-[10px]"
    />
    <div className="flex flex-row justify-center items-center gap-1 p-[16px]">
      <div className="w-[24px] h-[24px] md:w-[34px] md:h-[34px] flex rounded-[50px] justify-center items-center bg-black">
        <Iconify icon="lucide:map-pin" className="text-white" fontSize="8px" />
      </div>
      <Typography
        variant="h4"
        component="span"
        color={grey[900]}
        fontSize={{ xs: '12px', md: '16px', lg: '16px' }}
      >
        {props.name}
      </Typography>
    </div>
  </Paper>
);
